export default __webpack_public_path__ + "static/media/7.6bf4c92a.jpg";